export const emojiData = [
  {
    emoji: "😀",
    text: "grinning face",
  },
  {
    emoji: "🤯",
    text: "exploding head",
  },
  {
    emoji: "✊",
    text: "Raised Fist",
  },
  {
    emoji: "🧏",
    text: "Deaf Person",
  },
  {
    emoji: "🧑‍🎤",
    text: "Singer",
  },
  {
    emoji: "👩‍🚒",
    text: " Woman Firefighter",
  },
  {
    emoji: "👪",
    text: " Family",
  },
  {
    emoji: "👠",
    text: "High-Heeled Shoe",
  },
  {
    emoji: "🎓",
    text: "Graduation Cap",
  },
  {
    emoji: "🦮",
    text: "Guide Dog",
  },
  {
    emoji: "🐃 ",
    text: "Water Buffalo",
  },
  {
    emoji: "🦛",
    text: "Hippopotamus",
  },
  {
    emoji: "🪴",
    text: "Potted Plant",
  },
  {
    emoji: "🌰",
    text: "Chestnut",
  },
  {
    emoji: "🌍",
    text: " Globe Showing Europe-Africa",
  },
  {
    emoji: "🌐",
    text: "Globe with Meridians",
  },
  {
    emoji: "🌠",
    text: "Shooting Star",
  },
  {
    emoji: "🌪️",
    text: "Tornado",
  },
  {
    emoji: "🫐",
    text: "Blueberries",
  },
  {
    emoji: "🫑",
    text: "Bell Pepper",
  },
  {
    emoji: "🥐 ",
    text: "Croissant",
  },
  {
    emoji: "🍖 ",
    text: "Meat on Bone",
  },
  {
    emoji: "🥙",
    text: "Stuffed Flatbread",
  },
  {
    emoji: "🧆",
    text: "Falafel",
  },
  {
    emoji: "🍢 ",
    text: "Oden",
  },
  {
    emoji: "🍡 ",
    text: "Dango",
  },
  {
    emoji: "🥠",
    text: "Fortune Cookie",
  },
  {
    emoji: "🧉",
    text: "Mate",
  },
  {
    emoji: "🥡",
    text: "Takeout Box",
  },
  {
    emoji: "🚣‍♂️",
    text: " Man Rowing Boat",
  },
  {
    emoji: "🤸",
    text: "Person Cartwheeling",
  },
  {
    emoji: "🤼‍♀️",
    text: "Women Wrestling",
  },
  {
    emoji: "🤹‍♂️",
    text: " Man Juggling",
  },
  {
    emoji: "🧘‍♂️",
    text: "Lotus Position",
  },
  {
    emoji: "🎗️",
    text: " Reminder Ribbon",
  },
  {
    emoji: " 🥉",
    text: " 3rd Place Medal",
  },
  {
    emoji: "⛳",
    text: "Flag in Hole",
  },
  {
    emoji: "🎰",
    text: " Slot Machine",
  },
  {
    emoji: "🎯",
    text: " Direct Hit",
  },
  {
    emoji: "🥌",
    text: " Curling Stone",
  },
  {
    emoji: "🗻",
    text: " Mount Fuji",
  },
  {
    emoji: "🏜️",
    text: " Desert",
  },
  {
    emoji: "🏟️",
    text: " Stadium",
  },
  {
    emoji: "🏪",
    text: " Convenience Store",
  },
  {
    emoji: "🗽",
    text: " Statue of Liberty",
  },
  {
    emoji: "🕌",
    text: " Mosque",
  },
  {
    emoji: "🏙️ ",
    text: "Cityscape",
  },
  {
    emoji: "🌄 ",
    text: "Sunrise Over Mountains",
  },
  {
    emoji: "🚂",
    text: " Locomotive",
  },
  {
    emoji: "🚇",
    text: " Metro",
  },
  {
    emoji: "🚅",
    text: " Bullet Train",
  },
  {
    emoji: "🚄 ",
    text: "High-Speed Train",
  },
  {
    emoji: "🚖",
    text: " Oncoming Taxi",
  },
  {
    emoji: "🛺",
    text: " Auto Rickshaw",
  },
  {
    emoji: "🛤️ ",
    text: "Railway Track",
  },
  {
    emoji: "🛳️",
    text: " Passenger Ship",
  },
  {
    emoji: "⛴️",
    text: "Ferry",
  },
  {
    emoji: "🚟 ",
    text: "Suspension Railway",
  },
  {
    emoji: "💷",
    text: "Pound Banknote",
  },
  {
    emoji: "🗿 ",
    text: "Moai",
  },
  {
    emoji: "🗺️ ",
    text: "World Map",
  },
  {
    emoji: "🧭 ",
    text: " Compass",
  },
  {
    emoji: "⌛ ",
    text: "Hourglass Done",
  },
  {
    emoji: "🎐 ",
    text: "Wind Chime",
  },
  {
    emoji: "🪀",
    text: " Yo-Yo",
  },
  {
    emoji: "🪡",
    text: " Sewing Needle",
  },
  {
    emoji: "📯",
    text: " Postal Horn",
  },
  {
    emoji: "🧮",
    text: " Abacus",
  },
  {
    emoji: "📼 ",
    text: "Videocassette",
  },
  {
    emoji: "🗞️ ",
    text: "Rolled-Up Newspaper",
  },
  {
    emoji: "🇹🇼 ",
    text: "Taiwan",
  },
  {
    emoji: "🏁 ",
    text: "Chequered Flag",
  },
  {
    emoji: "📡 ",
    text: "Satellite Antenna",
  },
  {
    emoji: "🧬",
    text: " DNA",
  },
  {
    emoji: "🖍️ ",
    text: "Crayon",
  },
  {
    emoji: "📊",
    text: " Bar Chart",
  },
  {
    emoji: "🧲 ",
    text: "Magnet",
  },
];
